module.exports = __webpack_public_path__ + "5fb76c78a114cfbcda1ca8beeeb86872.png";